// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("fonts/Inter-Thin.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("fonts/Inter-Thin.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("fonts/Inter-ThinItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("fonts/Inter-ThinItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("fonts/Inter-ExtraLight.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("fonts/Inter-ExtraLight.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("fonts/Inter-ExtraLightItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("fonts/Inter-ExtraLightItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("fonts/Inter-Light.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("fonts/Inter-Light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("fonts/Inter-LightItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("fonts/Inter-LightItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("fonts/Inter-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("fonts/Inter-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("fonts/Inter-Italic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("fonts/Inter-Italic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("fonts/Inter-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("fonts/Inter-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("fonts/Inter-MediumItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("fonts/Inter-MediumItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("fonts/Inter-SemiBold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("fonts/Inter-SemiBold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("fonts/Inter-SemiBoldItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("fonts/Inter-SemiBoldItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("fonts/Inter-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("fonts/Inter-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("fonts/Inter-BoldItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("fonts/Inter-BoldItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("fonts/Inter-ExtraBold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("fonts/Inter-ExtraBold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("fonts/Inter-ExtraBoldItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("fonts/Inter-ExtraBoldItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_32___ = new URL("fonts/Inter-Black.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_33___ = new URL("fonts/Inter-Black.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_34___ = new URL("fonts/Inter-BlackItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_35___ = new URL("fonts/Inter-BlackItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_36___ = new URL("fonts/Inter-roman.var.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_37___ = new URL("fonts/Inter-italic.var.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_38___ = new URL("fonts/Inter.var.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___);
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___);
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_33___);
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_34___);
var ___CSS_LOADER_URL_REPLACEMENT_35___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_35___);
var ___CSS_LOADER_URL_REPLACEMENT_36___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_36___);
var ___CSS_LOADER_URL_REPLACEMENT_37___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_37___);
var ___CSS_LOADER_URL_REPLACEMENT_38___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_38___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Inter";
  font-style: normal;
  font-weight: 100;
  font-display: swap;
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff");
}
@font-face {
  font-family: "Inter";
  font-style: italic;
  font-weight: 100;
  font-display: swap;
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff");
}

@font-face {
  font-family: "Inter";
  font-style: normal;
  font-weight: 200;
  font-display: swap;
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("woff");
}
@font-face {
  font-family: "Inter";
  font-style: italic;
  font-weight: 200;
  font-display: swap;
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("woff");
}

@font-face {
  font-family: "Inter";
  font-style: normal;
  font-weight: 300;
  font-display: swap;
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("woff");
}
@font-face {
  font-family: "Inter";
  font-style: italic;
  font-weight: 300;
  font-display: swap;
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("woff");
}

@font-face {
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format("woff");
}
@font-face {
  font-family: "Inter";
  font-style: italic;
  font-weight: 400;
  font-display: swap;
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format("woff");
}

@font-face {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-display: swap;
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format("woff");
}
@font-face {
  font-family: "Inter";
  font-style: italic;
  font-weight: 500;
  font-display: swap;
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_18___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_19___}) format("woff");
}

@font-face {
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-display: swap;
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_20___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_21___}) format("woff");
}
@font-face {
  font-family: "Inter";
  font-style: italic;
  font-weight: 600;
  font-display: swap;
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_22___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_23___}) format("woff");
}

@font-face {
  font-family: "Inter";
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_24___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_25___}) format("woff");
}
@font-face {
  font-family: "Inter";
  font-style: italic;
  font-weight: 700;
  font-display: swap;
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_26___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_27___}) format("woff");
}

@font-face {
  font-family: "Inter";
  font-style: normal;
  font-weight: 800;
  font-display: swap;
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_28___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_29___}) format("woff");
}
@font-face {
  font-family: "Inter";
  font-style: italic;
  font-weight: 800;
  font-display: swap;
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_30___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_31___}) format("woff");
}

@font-face {
  font-family: "Inter";
  font-style: normal;
  font-weight: 900;
  font-display: swap;
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_32___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_33___}) format("woff");
}
@font-face {
  font-family: "Inter";
  font-style: italic;
  font-weight: 900;
  font-display: swap;
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_34___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_35___}) format("woff");
}

@font-face {
  font-family: "Inter var";
  font-weight: 100 900;
  font-style: normal;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_36___}) format("woff2");
}
@font-face {
  font-family: "Inter var";
  font-weight: 100 900;
  font-style: italic;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_37___}) format("woff2");
}

// Legacy naming compatibility
@font-face {
  font-family: "Inter var alt";
  font-weight: 100 900;
  font-style: normal;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_36___}) format("woff2");
}
@font-face {
  font-family: "Inter var alt";
  font-weight: 100 900;
  font-style: italic;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_37___}) format("woff2");
}

@font-face {
  font-family: "Inter var experimental";
  font-weight: 100 900;
  font-style: oblique 0deg 10deg;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_38___}) format("woff2");
}
`, "",{"version":3,"sources":["webpack://./src/styles/_inter.scss"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;;0DAE6C;AAC/C;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;;0DAEmD;AACrD;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;;0DAEmD;AACrD;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;;0DAEyD;AAC3D;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;;0DAE8C;AAChD;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;;2DAEoD;AACtD;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;;2DAEgD;AAClD;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;;2DAE+C;AACjD;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;;2DAE+C;AACjD;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;;2DAEqD;AACvD;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;;2DAEiD;AACnD;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;;2DAEuD;AACzD;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;;2DAE6C;AAC/C;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;;2DAEmD;AACrD;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;;2DAEkD;AACpD;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;;2DAEwD;AAC1D;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;;2DAE8C;AAChD;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;;2DAEoD;AACtD;;AAEA;EACE,wBAAwB;EACxB,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;EAClB,6DAAuD;AACzD;AACA;EACE,wBAAwB;EACxB,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;EAClB,6DAAwD;AAC1D;;AAEA;;EAEE,4BAA4B;EAC5B,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;EAClB,6DAAuD;AACzD;AACA;EACE,4BAA4B;EAC5B,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;EAClB,6DAAwD;AAC1D;;AAEA;EACE,qCAAqC;EACrC,oBAAoB;EACpB,8BAA8B;EAC9B,kBAAkB;EAClB,6DAAiD;AACnD","sourcesContent":["@font-face {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 100;\n  font-display: swap;\n  src:\n    url(\"fonts/Inter-Thin.woff2\") format(\"woff2\"),\n    url(\"fonts/Inter-Thin.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: \"Inter\";\n  font-style: italic;\n  font-weight: 100;\n  font-display: swap;\n  src:\n    url(\"fonts/Inter-ThinItalic.woff2\") format(\"woff2\"),\n    url(\"fonts/Inter-ThinItalic.woff\") format(\"woff\");\n}\n\n@font-face {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 200;\n  font-display: swap;\n  src:\n    url(\"fonts/Inter-ExtraLight.woff2\") format(\"woff2\"),\n    url(\"fonts/Inter-ExtraLight.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: \"Inter\";\n  font-style: italic;\n  font-weight: 200;\n  font-display: swap;\n  src:\n    url(\"fonts/Inter-ExtraLightItalic.woff2\") format(\"woff2\"),\n    url(\"fonts/Inter-ExtraLightItalic.woff\") format(\"woff\");\n}\n\n@font-face {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 300;\n  font-display: swap;\n  src:\n    url(\"fonts/Inter-Light.woff2\") format(\"woff2\"),\n    url(\"fonts/Inter-Light.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: \"Inter\";\n  font-style: italic;\n  font-weight: 300;\n  font-display: swap;\n  src:\n    url(\"fonts/Inter-LightItalic.woff2\") format(\"woff2\"),\n    url(\"fonts/Inter-LightItalic.woff\") format(\"woff\");\n}\n\n@font-face {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 400;\n  font-display: swap;\n  src:\n    url(\"fonts/Inter-Regular.woff2\") format(\"woff2\"),\n    url(\"fonts/Inter-Regular.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: \"Inter\";\n  font-style: italic;\n  font-weight: 400;\n  font-display: swap;\n  src:\n    url(\"fonts/Inter-Italic.woff2\") format(\"woff2\"),\n    url(\"fonts/Inter-Italic.woff\") format(\"woff\");\n}\n\n@font-face {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 500;\n  font-display: swap;\n  src:\n    url(\"fonts/Inter-Medium.woff2\") format(\"woff2\"),\n    url(\"fonts/Inter-Medium.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: \"Inter\";\n  font-style: italic;\n  font-weight: 500;\n  font-display: swap;\n  src:\n    url(\"fonts/Inter-MediumItalic.woff2\") format(\"woff2\"),\n    url(\"fonts/Inter-MediumItalic.woff\") format(\"woff\");\n}\n\n@font-face {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 600;\n  font-display: swap;\n  src:\n    url(\"fonts/Inter-SemiBold.woff2\") format(\"woff2\"),\n    url(\"fonts/Inter-SemiBold.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: \"Inter\";\n  font-style: italic;\n  font-weight: 600;\n  font-display: swap;\n  src:\n    url(\"fonts/Inter-SemiBoldItalic.woff2\") format(\"woff2\"),\n    url(\"fonts/Inter-SemiBoldItalic.woff\") format(\"woff\");\n}\n\n@font-face {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 700;\n  font-display: swap;\n  src:\n    url(\"fonts/Inter-Bold.woff2\") format(\"woff2\"),\n    url(\"fonts/Inter-Bold.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: \"Inter\";\n  font-style: italic;\n  font-weight: 700;\n  font-display: swap;\n  src:\n    url(\"fonts/Inter-BoldItalic.woff2\") format(\"woff2\"),\n    url(\"fonts/Inter-BoldItalic.woff\") format(\"woff\");\n}\n\n@font-face {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 800;\n  font-display: swap;\n  src:\n    url(\"fonts/Inter-ExtraBold.woff2\") format(\"woff2\"),\n    url(\"fonts/Inter-ExtraBold.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: \"Inter\";\n  font-style: italic;\n  font-weight: 800;\n  font-display: swap;\n  src:\n    url(\"fonts/Inter-ExtraBoldItalic.woff2\") format(\"woff2\"),\n    url(\"fonts/Inter-ExtraBoldItalic.woff\") format(\"woff\");\n}\n\n@font-face {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 900;\n  font-display: swap;\n  src:\n    url(\"fonts/Inter-Black.woff2\") format(\"woff2\"),\n    url(\"fonts/Inter-Black.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: \"Inter\";\n  font-style: italic;\n  font-weight: 900;\n  font-display: swap;\n  src:\n    url(\"fonts/Inter-BlackItalic.woff2\") format(\"woff2\"),\n    url(\"fonts/Inter-BlackItalic.woff\") format(\"woff\");\n}\n\n@font-face {\n  font-family: \"Inter var\";\n  font-weight: 100 900;\n  font-style: normal;\n  font-display: swap;\n  src: url(\"fonts/Inter-roman.var.woff2\") format(\"woff2\");\n}\n@font-face {\n  font-family: \"Inter var\";\n  font-weight: 100 900;\n  font-style: italic;\n  font-display: swap;\n  src: url(\"fonts/Inter-italic.var.woff2\") format(\"woff2\");\n}\n\n// Legacy naming compatibility\n@font-face {\n  font-family: \"Inter var alt\";\n  font-weight: 100 900;\n  font-style: normal;\n  font-display: swap;\n  src: url(\"fonts/Inter-roman.var.woff2\") format(\"woff2\");\n}\n@font-face {\n  font-family: \"Inter var alt\";\n  font-weight: 100 900;\n  font-style: italic;\n  font-display: swap;\n  src: url(\"fonts/Inter-italic.var.woff2\") format(\"woff2\");\n}\n\n@font-face {\n  font-family: \"Inter var experimental\";\n  font-weight: 100 900;\n  font-style: oblique 0deg 10deg;\n  font-display: swap;\n  src: url(\"fonts/Inter.var.woff2\") format(\"woff2\");\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
